export enum TransactionType {
    BUY = 'BUY',
    SELL = 'SELL'
}

export enum TransactionType_NewIon {
    BUY = '1',
    SELL = '2'
}

export interface NotificationSetting {
    user: number; // Assuming this is the user ID
    index: string; // The index, related to 'entry['Strategy']' in your Vue component
    price_threshold: number; // The price threshold
    type: 'above' | 'below'; // The type, restricted to 'above' or 'below'
}

export interface User {
    password: string;
    first_name: string;
    last_name: string;
    email: string;
    initials: string;
    id: number;
    is_staff: boolean;
    token: string;
}

export interface PasswordRequestToken {
    email: string,
}

export interface IndexChartTick {
    chart: boolean,
    index_id: number
}

export interface PasswordChangeRequest {
    password: string,
    token: string,

}


export interface LoginPayload {
    email: string,
    password: string
}

export interface UserDataType {
    email: string;
    password: string;
    token: string;
    is_staff: string;
    initials: string;
    first_name: string;
    id: number;
    last_name: string;
}

export interface Bond {
    id?: number;
    cusip: string;
    coupon: number;
}

export interface Index {
    id?: number;
    strat_name: string;
    is_active: boolean;
    trader: number;
    creator: number;
    chart: boolean;
    productline_index: Array<ProductLine>;
    is_submitted: boolean;
    is_yield: boolean;
    is_forward: boolean;
    created_at: Date;
    readonly cix?: string;
}

export interface Order {
    order_id?: string;
    order_name: string;
    order_description: string;
    verb_str: string;
    order_value: number;
    qty_fill: number;
    new_order_value: number;
    trd_value_avg: number;
    qty_goal: number;
    drop: number;
    user_text: string;
    dtc: boolean;
    edit: boolean;
    qty_offset: number;
    price_offset: number;

}

export interface ClientOrder {
    order_id?: string;
    order_name: string;
    order_description: string;
    verb_str: string;
    order_value: number;
    qty_fill: number;
    new_order_value: number;
    trd_value_avg: number;
    qty_goal: number;
    drop: number;
    user_text: string;
}

export interface OrderUsers {
    user_text: string;

}

export interface ProductLine {
    id?: number;
    index?: number;
    is_key_contract: boolean;
    product: number;
    price_ratio: number;
    trade_ratio: number;
    transaction_type: TransactionType;
    transaction_type_new_ion: TransactionType_NewIon;
}

export interface ProductSpec {
    id: number;
    is_spread: boolean;
    _type: string;
    base_name: string;
    currency: string;
    split: boolean;
}

export interface Product {
    id: number;
    name: string;
    ord_s: number | null;
    key: string;

    [key: string]: any;

    product_spec: ProductSpec;
    bond: Bond;
    exchange_name: string;
}

export interface ProductD {
    id: number;
    name: string;
    product_spec: ProductSpec;
    bond: Bond;
    exchange_name: string;
    d_page: boolean;
}

export interface Drift {
    exchangeName: string;
    midPrice: number;
    midPriceDict: number;
    midPriceDrift: number;
    yyieldDict: number;
    yyieldLive: number;
    last_delivery: string;
    yyieldDrift: number;
}

export interface Yield {
    product: number;
    price?: number;  // Optional for backward calculation
    yield_value?: number;  // Optional for backward calculation (alternative to leg)
    leg?: number;  // Optional for backward calculation (alias for yield_value)
    ratio: number;
    forward: boolean;  // true = Price→Yield, false = Yield→Price
}

export interface RepoBond {
    id?: number;
    cusip: string;
    product_bond: Product;
}

export interface Repo {
    bond: Bond;
    product_name: string;
    rate: number;
    repo_drop: number;
    accured: number;
    close: number;
}

export interface ChartData {
    strat_name: string;
    ratios_five_min: string[];
    ratios_calculated_price: number[];
}

export enum IndicesCategories {
    ASSIGNED = 'assigned',
    HOUSE = 'house',
    USERS = 'users'
}
